export const EMAIL_CHANNEL_PROTOCOLS = Object.freeze([
  "pop3",
  "pop3_over_ssl",
  "imap",
  "imap_over_ssl",
]);
